export class MissingParamsError<RequiredParamsType = string> extends Error {
  constructor(public missingParams: RequiredParamsType[]) {
    super(`Not sufficient parameters to request quotes. Missing parameters: ${missingParams.join(', ')}`);
  }
}
